<style scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body,
html {
    width: 100%;
    height: 100%;
    font-size: 1rem;
    font-family: 'Helvetica', 'Arial', sans-serif;
}

.contenedorContacto {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    /*background: rgba(6, 40, 60, 0.8);*/
    background-color: #000;
    padding: 10px;
    width: 100%;
    /* Ancho completo de la pantalla */
    margin: auto;
    /* Centra el contenedor */
    /*height: 1%;*/
    height: auto;
    margin-top: 3%;
    padding: 5%;

}

.contenedorNegro {
    background-color: #06283c;
    /* Color de fondo negro */
    color: white;
    /* Color del texto */
    padding: 20px;
    height: 60vh;
    /* Espaciado interior height: 90vh;*/
}

.contenedorSucursales {
    background-color: #fff;
    /* Color de fondo negro */
    color: #fff;
    /* Color del texto */
    padding: 20px;
    height: auto;
    text-align: center;
    /* Espaciado interior */
}

.contenedorDos {
    grid-template-columns: 1fr;
    gap: 10px;
    background-color: #000;
    padding: 10px;
    width: 100%;
    /* Ancho completo de la pantalla */
    margin: 0 auto;
    /* Centra el contenedor */
    /*height: 1%;*/
    height: 80vh;
}

.contenedorContacto .rowclass {
    display: flex;
    justify-content: space-around;
    padding: 10px;
}

.contenedorContacto .card {
    background-color: white;
    color: black;
    text-align: center;
    padding: 10px;
    height: auto;
    margin-left: 1%;
    margin-right: 1%;
}

.contenedorContacto .card .row {
    margin-top: 10px;
}

.iconoGrande {
    color: #ff9900;
    font-size: 2em;
}

.iconoChico {
    color: #ff9900;
    font-size: 1em;
}

.textoRedes {

    font-size: 1em;
}

#grid {
    display: grid;
    grid-template-rows: 40vh 40vh;
    grid-auto-flow: column;
    grid-gap: 5px;
}

#grid>div {
    background-color: white;
    color: white;
    font-size: 4vw;
    padding: 10px;
}

.div {
    /*background-color: #333;*/
    color: #333;
    font-size: 2vw;
    padding: 10px;
}

.boton-enlace {
    display: inline-block;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    background-color: #3498db;
    color: #ffffff;
    border-radius: 5px;
    transition: background-color 0.3s;
}

/* Cambiar color de fondo al pasar el mouse sobre el botón */
.boton-enlace:hover {
    background-color: #2980b9;
}

/*Estilo Form */




h3 {
    text-align: center;
    color: #666;

    margin: 0px 0px 0px 0px
}


.contenidoNegro {
    background-color: #000;
    color: white;
    padding: 20px;
    z-index: 1;
    /* Asegura que el contenedorNegro esté en una capa superior */
}

.align-left {
    text-align: left;

}

.formatoTexto {
    font-family: 'Helvetica', 'Arial', sans-serif;
    font-style: italic;
    text-align: center;
}

.formatoTexto2 {
    font-family: 'Helvetica', 'Arial', sans-serif;

    text-align: start;
}

/*form vue*/
.vue-form {
    font-size: 10px;
    width: 80%;
    padding: 15px 30px;
    border-radius: 4px;
    margin: 50px auto;
    background-color: #fff;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
}

.g-recaptcha {
    display: flex;
    justify-content: center;
    /* Centra horizontalmente */
    align-items: center;
    /* Centra verticalmente si hay suficiente altura */
    width: 100%;
    /* Ocupa todo el ancho disponible */
    padding: 10px;
    /* Espacio interno */
    box-sizing: border-box;
    /* Incluye padding en el cálculo del ancho */
    margin-top: 20px;
    margin-bottom: 20px;
}

.col2-form {
    font-size: 16px;
    width: 100%;
    padding: 15px 30px;

    margin: 50% auto;
    color: white;

}

.vue-form fieldset {
    margin: 0 0 0 0;
}

.vue-form legend {
    padding-bottom: 10px;
    border-bottom: 1px solid #ecf0f1;
}

.vue-form div {
    position: relative;
    margin: 0 0;
}

.vue-form h4,
.vue-form .label {
    color: #333;
    margin-bottom: 5px;
}

.vue-form .label {
    display: block;
}

.vue-form input,
.vue-form textarea,
.vue-form select,
.vue-form label {
    color: #2b3e51;
}

.vue-form input[type="text"],
.vue-form input[type="email"],
.vue-form textarea,
.vue-form select,
.vue-form legend {
    display: block;
    width: 100%;
    appearance: none;
}

.vue-form input[type="text"],
.vue-form input[type="email"],
.vue-form textarea,
.vue-form select {
    padding: 12px;
    border: 1px solid #cfd9db;
    background-color: #ffffff;
    border-radius: 0.25em;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
}

.vue-form input[type="text"]:focus,
.vue-form input[type="email"]:focus,
.vue-form textarea:focus,
.vue-form select:focus {
    outline: none;
    border-color: #2c3e50;
    box-shadow: 0 0 5px rgba(44, 151, 222, 0.2);
}

.vue-form .select {
    position: relative;
}

.vue-form .select::after {
    content: "";
    position: absolute;
    z-index: 1;
    right: 16px;
    top: 50%;
    margin-top: -8px;
    display: block;
    width: 16px;
    height: 16px;
    background: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cg%3E%0D%0A%09%3Cpolygon%20fill%3D%22%232c3e50%22%20points%3D%220.9%2C5.5%203.1%2C3.4%208%2C8.3%2012.9%2C3.4%2015.1%2C5.5%208%2C12.6%20%09%22%2F%3E%0D%0A%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E") no-repeat center center;
    pointer-events: none;
}

.vue-form select {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    cursor: pointer;
}

.vue-form select::-ms-expand {
    display: none;
}

.vue-form .vue-form-list {
    margin-top: 16px;
}

.vue-form .vue-form-list::after {
    clear: both;
    content: "";
    display: table;
}

.vue-form .vue-form-list li {
    display: inline-block;
    position: relative;
    user-select: none;
    margin: 0 26px 16px 0;
}

.vue-form input[type="radio"],
.vue-form input[type="checkbox"] {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    padding: 0;
    opacity: 0;
    z-index: 2;
}

.vue-form input[type="radio"]+label,
.vue-form input[type="checkbox"]+label {
    padding-left: 24px;
}

.vue-form input[type="radio"]+label::before,
.vue-form input[type="radio"]+label::after,
.vue-form input[type="checkbox"]+label::before,
.vue-form input[type="checkbox"]+label::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -8px;
    width: 16px;
    height: 16px;
}

.vue-form input[type="radio"]+label::before,
.vue-form input[type="checkbox"]+label::before {
    border: 1px solid #cfd9db;
    background: #ffffff;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
}

.vue-form input[type="radio"]+label::before,
.vue-form input[type="radio"]+label::after {
    border-radius: 50%;
}

.vue-form input[type="checkbox"]+label::before,
.vue-form input[type="checkbox"]+label::after {
    border-radius: 0.25em;
}

.vue-form input[type="radio"]+label::after,
.vue-form input[type="checkbox"]+label::after {
    background-color: #2c3e50;
    background-position: center center;
    background-repeat: no-repeat;
    box-shadow: 0 0 5px rgba(44, 151, 222, 0.4);
    display: none;
}

.vue-form input[type="radio"]+label::after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%223%22%2F%3E%0D%0A%3C%2Fsvg%3E");
}

.vue-form input[type="checkbox"]+label::after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2018.1.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cpolyline%20fill%3D%22none%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22square%22%20stroke-miterlimit%3D%2210%22%20points%3D%225%2C8%207%2C10%2011%2C6%20%22%2F%3E%0D%0A%3C%2Fsvg%3E");
}

.vue-form input[type="radio"]:focus+label::before,
.vue-form input[type="checkbox"]:focus+label::before {
    box-shadow: 0 0 5px rgba(44, 151, 222, 0.6);
}

.vue-form input[type="radio"]:checked+label::after,
.vue-form input[type="checkbox"]:checked+label::after {
    display: block;
}

.vue-form input[type="radio"]:checked+label::before,
.vue-form input[type="radio"]:checked+label::after,
.vue-form input[type="checkbox"]:checked+label::before,
.vue-form input[type="checkbox"]:checked+label::after {
    animation: cd-bounce 0.3s;
}

.vue-form textarea {
    min-height: 120px;
    resize: vertical;
    overflow: auto;
}

.vue-form input[type="submit"] {
    border: none;
    background: #ff9900;
    border-radius: 0.25em;
    padding: 12px 20px;
    color: #ffffff;
    font-weight: bold;
    float: right;
    cursor: pointer;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    appearance: none;
}

.no-touch .vue-form input[type="submit"]:hover {
    background: #42a2e1;
}

.vue-form input[type="submit"]:focus {
    outline: none;
    background: #2b3e51;
}

.vue-form input[type="submit"]:active {
    transform: scale(0.9);
}

.vue-form .error-message {
    height: 35px;
    margin: 0px;
}

.vue-form .error-message p {
    background: #e94b35;
    color: #ffffff;
    font-size: 1.4rem;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border-radius: 0.25em;
    padding: 16px;
}

.vue-form .error {
    border-color: #e94b35 !important;
}

.vue-form .counter {
    color: #2c3e50;
    position: absolute;
    right: 0px;
    top: 0px;
    font-size: 10px;
    padding: 4px;
}

.debug {
    border-radius: 4px;
    margin: 50px auto;
    width: 500px;
    background-color: #000;
    padding: 50px;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
}

.debug pre {
    color: #ffffff;
    font-size: 18px;
    line-height: 30px;
    font-family: "Source Code Pro", monospace;
    font-weight: 300;
    white-space: pre-wrap;
}

.abierto {
    color: green;
}

.cerrado {
    color: red;
}

@-webkit-keyframes cd-bounce {

    0%,
    100% {
        -webkit-transform: scale(1);
    }

    50% {
        -webkit-transform: scale(0.8);
    }
}

@-moz-keyframes cd-bounce {

    0%,
    100% {
        -moz-transform: scale(1);
    }

    50% {
        -moz-transform: scale(0.8);
    }
}

@keyframes cd-bounce {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.8);
    }
}

@media (max-width: 1366px) {
    .contenedorContacto {
        height: auto;
        margin-top: 10%;

    }

    .contenedorDos {
        height: auto;
    }

}

.callout {
    padding: 20px;
    margin: 10% 30%;

    border-left-width: 5px;
    border-radius: 3px;
    width: 70%
}

.callout h5 {
    margin-top: 0;
    margin-bottom: 5px;
    color: #ffffff;
}

.callout p:last-child {
    margin-bottom: 0;
}

.callout code {
    border-radius: 3px;
}

.callout+.bs-callout {
    margin-top: -5px;
}

.callout-danger {
    border-left-color: #ff9900;
}

.Icontransparent {
    color: transparent;
    /* Hacer el contenido del icono transparente */
    -webkit-text-stroke-width: 3px;
    -webkit-text-stroke-color: #eaeae8;

}

@media (max-width: 768px) {
    .formatoTexto2 {
        text-align: center;
    }

    /* Estilos para pantallas más pequeñas */
    .g-recaptcha {
        padding: 5px;
        /* Reduce el padding en pantallas más pequeñas */
    }

    .contenedorSucursales {
        height: auto;
    }
}

@media (max-width: 480px) {

    /* Estilos para pantallas muy pequeñas */
    .g-recaptcha {
        padding: 2px;
        /* Reduce aún más el padding en pantallas muy pequeñas */
    }
}
</style>

<template>
    <div class="contenedorContacto" v-if="sucursalesDataPrincipal">
        <div class="row">

            <h3>Contáctenos</h3>
            <h6 style="color:#ff9900;">¿Alguna pregunta o comentario? ¡Solo escríbenos un mensaje!</h6>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 mb-4">
                <div class="card text-center">
                    <div class="card-body">
                        <div class="row ">
                            <i class="fa fa-map-marker iconoGrande" aria-hidden="true" role="img"></i>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-12">
                                <h5 class="card-title"><span class="formatoTexto"></span>Oficina Principal</h5>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-3 col-sm-12">
                                <i class="bx bx-building" aria-hidden="true" style="text-align: center;"></i>
                            </div>
                            <div class="col-md-9 col-sm-12">
                                <h5 class="textoRedes">
                                    <span class="formatoTexto2">{{ sucursalesDataPrincipal.descripcion }}</span>
                                </h5>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-3 col-sm-12">
                                <i class="bx bx-calendar-check" aria-hidden="true"
                                    :class="{ 'abierto': isAbierto(sucursalesDataPrincipal), 'cerrado': !isAbierto(sucursalesDataPrincipal) }"
                                    style="text-align: center;"></i>
                            </div>
                            <div class="col-md-9 col-sm-12" v-if="isWeekday()">
                                <span
                                    :class="{ 'abierto': isAbierto(sucursalesDataPrincipal), 'cerrado': !isAbierto(sucursalesDataPrincipal) }">
                                    {{ isAbierto(sucursalesDataPrincipal) ? 'Abierto' : 'Cerrado' }}
                                </span>
                                <span>
                                    - Lun-Vie {{ sucursalesDataPrincipal.horaapertura }}-{{
                                        sucursalesDataPrincipal.horacierre }}
                                </span>
                            </div>
                            <!-- Horario secundario -->
                            <div class="col-md-9 col-sm-12"
                                v-if="isSaturday() && sucursalesDataPrincipal.horaaperturaSec && sucursalesDataPrincipal.horacierreSec">
                                <span
                                    :class="{ 'abierto': isAbierto(sucursalesDataPrincipal, true), 'cerrado': !isAbierto(sucursalesDataPrincipal, true) }">
                                    {{ isAbierto(sucursalesDataPrincipal, true) ? 'Abierto' : 'Cerrado'
                                    }}
                                </span>
                                <span>
                                    - Sábado {{ sucursalesDataPrincipal.horaaperturaSec }}-{{
                                        sucursalesDataPrincipal.horacierreSec }}
                                </span>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 mb-4">
                <div class="card text-center" style="min-height: 23vh;">
                    <div class="card-body">
                        <div class="row ">
                            <i class="bx bx-phone-call iconoGrande" aria-hidden="true" role="img"></i>
                        </div>
                        <div class="row">
                            <h5 class="card-title">Número de teléfono</h5>
                        </div>
                        <div class="row" v-if="sucursalesDataPrincipal.telefonoprin">
                            <div class="col-md-3 col-sm-12">
                                <i class="fa fa-phone-square" aria-hidden="true"></i>
                            </div>
                            <div class="col-md-9 col-sm-12">
                                <p>{{ sucursalesDataPrincipal.telefonoprin }}</p>
                            </div>
                        </div>
                        <div class="row" v-if="sucursalesDataPrincipal.telefonosec">
                            <div class="col-md-3 col-sm-12">
                                <i class="fa fa-phone-square" aria-hidden="true"></i>
                            </div>
                            <div class="col-md-9 col-sm-12">
                                <p>{{ sucursalesDataPrincipal.telefonosec }}</p>
                            </div>
                        </div>
                        <div class="row" v-if="sucursalesDataPrincipal.telefonoter">
                            <div class="col-md-3 col-sm-12">
                                <i class="fa fa-phone-square" aria-hidden="true"></i>
                            </div>
                            <div class="col-md-9 col-sm-12">
                                <p>{{ sucursalesDataPrincipal.telefonoter }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 mb-4">
                <div class="card text-center" style="min-height: 23vh;">
                    <div class="card-body">
                        <div class="row ">
                            <i class="bx bx-envelope-open iconoGrande" aria-hidden="true" role="img"></i>
                        </div>
                        <div class="row">
                            <h5 class="card-title">Correo</h5>

                        </div>
                        <div class="row">
                            <h6 class="textoRedes" v-if="sucursalesDataPrincipal.correoprinc">{{
                                sucursalesDataPrincipal.correoprinc }}</h6>
                            <h6 class="textoRedes" v-if="sucursalesDataPrincipal.correosec">{{
                                sucursalesDataPrincipal.correosec }}</h6>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 mb-4">
                <div class="card text-center" style="min-height: 23vh;">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <div class="row">
                                    <i class="fa fa-share-alt iconoGrande" aria-hidden="true" role="img"></i>
                                </div>
                                <div class="row">
                                    <h5 class="card-title">Redes Sociales</h5>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="display: flex; flex-direction: row; flex-wrap: wrap;">
                            <template v-for="red in sucursalesDataPrincipal.redes">
                                <div class="col-md-6 col-lg-4 col-sm-12">
                                    <a :href="getRedSocialLink(red)" target="_blank"
                                        style="text-decoration: none; color: inherit;">
                                        <div class="row">
                                            <!-- Usa directamente el campo icono del modelo relacionado -->
                                            <i :class="red.red_social.icono" aria-hidden="true" role="img"></i>
                                        </div>
                                        <div class="row">
                                            <!-- Muestra el nombre de la red social -->
                                            <h5 class="textoRedes">{{ red.red_social.name }}</h5>
                                        </div>
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row">
                <h3>Si tiene alguna pregunta, no dude en ponerse en contacto con nosotros:</h3>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="col2-form">
                        <h4>¿Quieres formar parte de nuestros clientes?</h4>
                        <!--<router-link :to="{ path: '/ruta-con-id', hash: '#unete' }" class="btn btn-outline-danger btn-lg">ÚNETE</router-link>-->
                        <a href="#unete" class="boton-enlace">ÚNETE</a>
                    </div>

                </div>
                <div class="col-md-9">
                    <form class="vue-form" @submit.prevent="submitContactForm">
                        <div>
                            <h5>ENVÍANOS UN MENSAJE</h5>
                        </div>
                        <div v-if="submitted">
                            <p>¡El formulario se ha enviado con éxito!</p>

                        </div>
                        <fieldset>
                            <div class="row" style="margin-bottom: 0;margin-top: 0;">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div>
                                        <label class="label" for="name">Nombre: </label>
                                        <input type="text" name="name" id="name" required=""
                                            v-model="formData.name.value">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div>
                                        <label class="label" for="apellido">Apellido(s):</label>
                                        <input type="text" name="apellido" id="apellido" required=""
                                            v-model="formData.apellido.value">
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-bottom: 0%;">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div>
                                        <label class="label" for="telefono">Teléfono:</label>
                                        <input type="text" name="telefono" id="telefono" required=""
                                            v-model="formData.telefono.value">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div>
                                        <label class="label" for="empresa">Empresa:</label>
                                        <input type="text" name="empresa" id="empresa" required=""
                                            v-model="formData.empresa.value">
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="margin-bottom: 0%;">
                                <div>
                                    <label class="label" for="email">Email:</label>
                                    <input type="email" name="email" id="email" required=""
                                        v-model="formData.email.value">
                                </div>
                            </div>
                            <div class="row">
                                <label class="label" for="textarea">Escribe tus comentarios</label>
                                <textarea class="message" name="textarea" id="textarea" required=""
                                    v-model="formData.message.text" :maxlength="formData.message.maxlength"></textarea>
                                <span class="counter">{{ formData.message.text.length }} / {{ formData.message.maxlength
                                    }}</span>
                            </div>
                            <div class="g-recaptcha" data-sitekey="6LdtaskqAAAAALWDMhG-qbHkF3BdqYEG754u0NUb"
                                data-callback="onContactCaptchaVerified"
                                data-expired-callback="onContactCaptchaExpired">
                            </div>
                            <button :disabled="!contactCaptchaVerified" type="submit" class="btn btn-warning"
                                style="background-color: #ff9900;color: #06283c;">Enviar</button>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="contenedorNegro">
    </div>-->
    <div class="contenedorSucursales">
        <div class="row">
            <div class="col-md-2">
            </div>
            <div class="col-md-8"
                style=" border-bottom: 2px solid #ff9900; /* Cambia #ffcc00 al color que desees */padding-bottom: 10px; /* Ajusta el espacio según sea necesario */">
                <h3 style="color:#000">MÁS DATOS DE CONTACTO</h3>
            </div>
            <div class="col-md-2">
            </div>
        </div>
        <div class="row">
            <div class="col-md-2" style="margin-left:5%;">
                <div v-for="(sucursal, index) in sucursales" :key="index" class="div"
                    style="font-size: 1rem;color: #ff9900;cursor: pointer;" @click="vistaSucursal(sucursal)">
                    {{ sucursal.descripcion }}
                </div>
            </div>
            <div class="col-md-5" style="margin-top:5%;">
                <iframe v-if="sucursalSel.maps" :src="'https://www.google.com/maps/embed?pb=' + sucursalSel.maps"
                    width="300" height="225" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                <!--
<iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.13277939347!2d-98.15983042479397!3d19.101830082108137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc18ae46a81ef%3A0x328243bd69266bba!2sJACVE%20COMERCIAL!5e0!3m2!1ses-419!2smx!4v1708846766927!5m2!1ses-419!2smx"
                    width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                -->
            </div>
            <div class="col-md-4" style="color:#333;margin-top:5%;font-size: 1rem;">

                <div class="row" v-if="sucursalSel.descripcion">
                    <i class="fa fa-map-marker fa-sm" aria-hidden="true" style="color:#ff9900;"></i>
                    <span>{{ sucursalSel.descripcion }}</span>
                </div>
                <div class="row" v-if="sucursalSel.telefonoprin" style="display: inline-flex;">
                    <i class="fa fa-phone fa-sm" aria-hidden="true" style="color:#ff9900;"></i>
                    <span>{{ sucursalSel.telefonoprin }}</span>
                </div>
                <div class="row" v-if="sucursalSel.correoprinc" style="display: inline-flex;">
                    <i class="fa fa-envelope-o fa-sm" aria-hidden="true" style="color:#ff9900;"></i>
                    <span>{{ sucursalSel.correoprinc }}</span>
                </div>
                <div class="row"
                    v-if="(sucursalSel.horaapertura && sucursalSel.horacierre) || (sucursalSel.horaaperturaSec && sucursalSel.horacierreSec)"
                    style="display: inline-flex;">
                    <i class="fa fa-clock-o fa-sm" aria-hidden="true" style="color:#ff9900;"></i>
                    <span v-if="sucursalSel.horaapertura && sucursalSel.horacierre">{{ 'Lun-Vie : ' +
                        sucursalSel.horaapertura + '-' + sucursalSel.horacierre }}</span>
                    <span v-if="sucursalSel.horaaperturaSec && sucursalSel.horacierreSec">{{ 'Sábado : ' +
                        sucursalSel.horaaperturaSec + '-' + sucursalSel.horacierreSec }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="contenedorDos" id="unete">
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-5"
                style=" border-bottom: 2px solid #ff9900; /* Cambia #ffcc00 al color que desees */padding-bottom: 10px; /* Ajusta el espacio según sea necesario */">
                <h3> ÚNETE A NUESTROS CLIENTES</h3>
            </div>
            <div class="col-md-3"></div>
        </div>
        <div class="row">
            <div class="col-md-7">
                <div class="row">
                    <div class="callout callout-danger">
                        <h5>Al unirte podrás realizar compras en nuestro sitio, acceder a la lista de precios, consultar
                            existencias y más.</h5>
                        <p>
                            Es necesario que te pongas en contacto especificando que quieres comprar con nosotros. Te
                            responderemos lo más pronto posible a través de tu correo o teléfono y te diremos cúal es el
                            siguiente paso.
                        </p>
                    </div>
                </div>
                <div class="row" style="margin-left:30%">
                    <div class="col-md-7"></div>
                    <div class="col-md-5"><i class="fa fa-user-plus fa-7x Icontransparent" aria-hidden="true"
                            role="img"></i></div>

                </div>
            </div>
            <div class="col-md-5">
                <form class="vue-form" @submit.prevent="submitJoinForm">
                    <fieldset>
                        <div class="row" style="margin-bottom: 0;margin-top: 0;">
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div>
                                    <label class="label" for="name">Nombre: </label>
                                    <input type="text" name="name" id="name" required="" v-model="formClientData.name">
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div>
                                    <label class="label" for="apellido">Apellido(s):</label>
                                    <input type="text" name="apellido" id="apellido" required=""
                                        v-model="formClientData.apellido">
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 0%;">
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div>
                                    <label class="label" for="telefono">Teléfono:</label>
                                    <input type="text" name="telefono" id="telefono" required=""
                                        v-model="formClientData.telefono">
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div>
                                    <label class="label" for="empresa">Empresa:</label>
                                    <input type="text" name="empresa" id="empresa" required=""
                                        v-model="formClientData.empresa">
                                </div>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 0%;">
                            <div>
                                <label class="label" for="email">Email:</label>
                                <input type="email" name="email" id="email" required="" v-model="formClientData.email">
                            </div>

                        </div>
                        <div class="row">
                            <label class="label" for="textarea">Detalles de la solicitud:</label>
                        </div>
                        <div class="row">
                            <textarea class="message" name="textarea" id="textarea" required=""
                                v-model="formClientData.message.text"
                                :maxlength="formClientData.message.maxlength"></textarea>
                            <span class="counter">{{ formClientData.message.text.length }} / {{
                                formClientData.message.maxlength }}</span>
                        </div>
                        <div class="row">
                            <label>¿Has sido cliente anteriormente de alguna de nuestras líneas?</label>
                            <div class="form-check">

                                <input class="form-check-input" type="checkbox"
                                    v-model="formClientData.previousClient.partech" id="partechCheckbox">
                                <label class="form-check-label" for="partechCheckbox">
                                    <strong>Partech:</strong>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="rodotechCheckbox"
                                    v-model="formClientData.previousClient.rodotech">
                                <label class="form-check-label" for="rodotechCheckbox">
                                    <strong>Partech:</strong>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="sharkWPCheckbox"
                                    v-model="formClientData.previousClient.sharkWP">
                                <label class="form-check-label" for="sharkWPCheckbox">
                                    <strong>Shark WP:</strong>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="eagleBHPCheckbox"
                                    v-model="formClientData.previousClient.eagleBHP">
                                <label class="form-check-label" for="eagleBHPCheckbox">
                                    <strong>Eagle BHP:</strong>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="trackoneCheckbox"
                                    v-model="formClientData.previousClient.trackone">
                                <label class="form-check-label" for="trackoneCheckbox">
                                    <strong>Trackone:</strong>
                                </label>
                            </div>
                        </div>
                        <div class="g-recaptcha" data-sitekey="6LdtaskqAAAAALWDMhG-qbHkF3BdqYEG754u0NUb"
                            data-callback="onJoinFormCaptchaVerified" data-expired-callback="onJoinFormCaptchaExpired"
                            style="margin-top: 20px;">
                        </div>
                        <button type="submit" :disabled="!joinFormCaptchaVerified" class="btn btn-warning"
                            style="background-color: #ff9900;color: #06283c;">Enviar</button>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>
<script>


export default {

    data() {

        return {
            detallesMatriz: false,
            detallesSecundaria: false,
            detallesTerciaria: false,
            sucursalesDataPrincipal: {},
            sucursales: {},
            empresasitekeyr: '',
            sucursalSeleccionada: 0, // La sucursal seleccionada
            submitted: false,
            sucursalSel: {
                descripcion: '',
                calle: '',
                noext: '',
                noint: '',
                municipio: '',
                cp: '',
                estado: '',
                calle: '',
                telefonoprin: '',
                correoprinc: '',
                horaapertura: '',
                horacierre: '',
                horaaperturaSec: '',
                horacierreSec: '',
                maps: '',
            },
            formData: new Form({
                name: {
                    value: '',
                    valid: true
                },
                email: {
                    value: '',
                    valid: true
                },
                apellido: {
                    value: '',
                    valid: true
                },
                telefono: {
                    value: '',
                    valid: true
                },
                empresa: {
                    value: '',
                    valid: true
                },
                message: {
                    text: ``,
                    maxlength: 255
                },
            }),
            formClientData: new Form({
                name: '',
                email: '',
                apellido: '',
                telefono: '',
                empresa: '',
                message: {
                    text: ``,
                    maxlength: 255
                },
                previousClient: {
                    partech: false,
                    rodotech: false,
                    sharkWP: false,
                    eagleBHP: false,
                    trackone: false
                    // Agrega más propiedades según sea necesario
                },
            }),
            contactCaptchaVerified: false, // Estado del captcha para el formulario de contacto
            joinFormCaptchaVerified: false,    // Estado del captcha para el formulario de unirse
        };
    },
    mounted() {
        window.onContactCaptchaVerified = this.onContactCaptchaVerified;
        window.onContactCaptchaExpired = this.onContactCaptchaExpired;
        window.onJoinFormCaptchaVerified = this.onJoinFormCaptchaVerified;
        window.onJoinFormCaptchaExpired = this.onJoinFormCaptchaExpired;
        this.sucursalescontacto()
        this.loadRecaptcha();
    },
    methods: {
        // submit form handler
        sucursalescontacto() {
            axios.get(`/api/admin/contactosucursales`)
                .then(response => {
                    // Manejar la respuesta del servidor
                    this.sucursalesDataPrincipal = response.data.principal
                    this.sucursales = response.data.sucursales
                    this.empresasitekeyr = response.data.ConfigEmpresa.sitekeyr
                    this.vistaSucursal(response.data.sucursales[0])
                })
                .catch(error => {
                    // Manejar el error en caso de que ocurra
                    console.error("Error al actualizar la sucursal:", error);
                });
        },
        loadRecaptcha() {
            if (typeof grecaptcha !== 'undefined' && this.empresasitekeyr) {
                // Limpia el contenedor del reCAPTCHA antes de volver a renderizar
                this.$refs.recaptcha.innerHTML = '';
                grecaptcha.render(this.$refs.recaptcha, {
                    sitekey: this.empresasitekeyr,
                    callback: this.onJoinFormCaptchaVerified,
                    'expired-callback': this.onJoinFormCaptchaExpired
                });
            }
        },
        vistaSuc(suc) {
            //console.log(this.detallesMatriz)
            if (suc == 1) {
                this.detallesMatriz = !this.detallesMatriz;
                this.detallesSecundaria = false;
                this.detallesTerciaria = false;
            }

            if (suc == 2) {
                this.detallesSecundaria = !this.detallesSecundaria
                this.detallesMatriz = false
                this.detallesTerciaria = false;
            }

            if (suc == 3) {
                this.detallesTerciaria = !this.detallesTerciaria
                this.detallesMatriz = false
                this.detallesSecundaria = false;
            }

        },
        submitContactForm: function () {
            var contactFormData = {
                name: this.formData.name.value,
                apellido: this.formData.apellido.value,
                telefono: this.formData.telefono.value,
                empresa: this.formData.empresa.value,
                email: this.formData.email.value,
                message: this.formData.message.text
            };
            axios.post('/api/contact/formContacto', contactFormData).then((response) => {
                this.submitted = true;
                this.formData.name.value = '';
                this.formData.email.value = '';
                this.formData.apellido.value = '';
                this.formData.telefono.value = '';
                this.formData.empresa.value = '';
                this.formData.message.text = '';

            })
                .catch(function (error) {
                    console.log(error);

                });
            // Enviar contactFormData al servidor para el formulario de contacto
            //console.log("Contact Form Data:", contactFormData);
            // axios.post('/serverPathForContactForm', contactFormData)

            //this.submitted = true;
        },
        submitContactFormNewClient: function () {
            var contactFormData = {
                name: this.formData.name.value,
                apellido: this.formData.apellido.value,
                telefono: this.formData.telefono.value,
                empresa: this.formData.empresa.value,
                email: this.formData.email.value,
                message: this.formData.message.text
            };
            axios.post('/api/contact/formContacto', contactFormData).then((response) => {
                //this.submitted = true;
                this.formData.name.value = '';
                this.formData.email.value = '';
                this.formData.apellido.value = '';
                this.formData.telefono.value = '';
                this.formData.empresa.value = '';
                this.formData.message.text = '';
                Swal.fire({
                    title: 'Éxito',
                    text: 'La solicitud se ha enviado correctamente, gracias por interactuar con nosotros.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                    timer: 2000, // Tiempo en milisegundos (3 segundos en este ejemplo)
                    timerProgressBar: true, // Barra de progreso del temporizador
                    onClose: () => {
                        // Acciones a realizar después de que se cierre el SweetAlert
                        console.log('SweetAlert cerrado automáticamente');
                    }
                });

            })
                .catch(function (error) {
                    console.log(error);

                });
            // Enviar contactFormData al servidor para el formulario de contacto
            //console.log("Contact Form Data:", contactFormData);
            // axios.post('/serverPathForContactForm', contactFormData)

            //this.submitted = true;
        },
        submitJoinForm: function () {


            // Enviar joinFormData al servidor para el formulario de unirse a clientes

            // axios.post('/serverPathForJoinForm', joinFormData)

            axios.post('/api/contact/formContactonewClient', this.formClientData).then((response) => {
                //this.submitted = true;
                this.formClientData.name = '';
                this.formClientData.email = '';
                this.formClientData.apellido = '';
                this.formClientData.telefono = '';
                this.formClientData.empresa = '';
                this.formClientData.message.text = '';
                // Reinicia las propiedades de previousClient si es necesario
                this.formClientData.previousClient.partech = false;
                this.formClientData.previousClient.rodotech = false;
                this.formClientData.previousClient.sharkWP = false;
                this.formClientData.previousClient.eagleBHP = false;
                this.formClientData.previousClient.trackone = false;
                Swal.fire({
                    title: 'Éxito',
                    text: 'La solicitud se ha enviado correctamente, en breve nos contactaremos contigo.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                    timer: 2000, // Tiempo en milisegundos (3 segundos en este ejemplo)
                    timerProgressBar: true, // Barra de progreso del temporizador
                    onClose: () => {
                        // Acciones a realizar después de que se cierre el SweetAlert
                        console.log('SweetAlert cerrado automáticamente');
                    }
                });

            })
                .catch(function (error) {
                    console.log(error);

                });


        },
        // validate by type and value
        validate: function (type, value) {
            if (type === "email") {
                this.email.valid = this.isEmail(value) ? true : false;
            }
        },
        // check for valid email adress
        isEmail: function (value) {
            return emailRegExp.test(value);
        },
        // check or uncheck all
        checkAll: function (event) {
            this.selection.features = event.target.checked ? this.features : [];
        },
        isAbierto(sucursal, isSecundario = false) {
            const now = new Date();
            const dayOfWeek = now.getDay(); // Obtener el día de la semana (0 para Domingo, 1 para Lunes, etc.)
            const horaActual = now.getHours() * 100 + now.getMinutes(); // Convertir la hora actual a un número entero (HHMM)

            if (!isSecundario) {
                // Verificar el horario primario
                if (sucursal.horaapertura !== undefined && sucursal.horacierre !== undefined) {
                    var horaApertura = parseInt(sucursal.horaapertura.toString().replace(':', ''), 10);
                    var horaCierre = parseInt(sucursal.horacierre.toString().replace(':', ''), 10);

                    // Verificar el horario primario
                    if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Lun-Vie
                        return horaActual >= horaApertura && horaActual <= horaCierre;
                    } else {
                        return false; // La sucursal está cerrada los fines de semana
                    }
                } else {
                    // Manejar el caso cuando los valores de hora de apertura y cierre son undefined
                    return false;
                }
            } else {
                // Verificar el horario secundario
                if (sucursal.horaaperturaSec !== undefined && sucursal.horacierreSec !== undefined) {
                    var horaAperturaSec = parseInt(sucursal.horaaperturaSec.toString().replace(':', ''), 10);
                    var horaCierreSec = parseInt(sucursal.horacierreSec.toString().replace(':', ''), 10);
                    if (dayOfWeek === 6) { // Sábado
                        return horaActual >= horaAperturaSec && horaActual <= horaCierreSec;
                    } else {
                        return false; // La sucursal está cerrada los días que no son sábado
                    }

                }
                else {
                    // Manejar el caso cuando los valores de hora de apertura y cierre son undefined
                    return false;
                }
            }
        },
        vistaSucursal(sucursal) {
            //console.log(sucursal)

            this.sucursalSel = {
                id: sucursal.id,
                descripcion: sucursal.descripcion,
                calle: sucursal.calle,
                noext: sucursal.noext,
                noint: sucursal.noint,
                municipio: sucursal.municipio,
                cp: sucursal.cp,
                estado: sucursal.estado,
                calle: sucursal.calle,
                telefonoprin: sucursal.telefonoprin,
                correoprinc: sucursal.correoprinc,
                horaapertura: sucursal.horaapertura,
                horacierre: sucursal.horacierre,
                horaaperturaSec: sucursal.horaaperturaSec,
                horacierreSec: sucursal.horacierreSec,
                maps: sucursal.maps,
            }
        },
        getRedSocialLink(red) {
            if (!red.red_social) return '#'; // Si no hay relación, devuelve un enlace vacío.

            const baseUrl = red.red_social.link || ''; // URL base de la red social.
            const admiteMensaje = red.red_social.admite_mensaje || 0; // Por defecto, no admite mensajes.
            const mensaje = red.red_social.mensaje || 'Hola, me gustaría obtener más información';

            // Si admite mensajes, personaliza el enlace con el mensaje.
            if (admiteMensaje) {
                const linkConMensaje = `${baseUrl}${red.valor || ''}?text=${encodeURIComponent(mensaje)}`;
                return linkConMensaje;
            }

            // Si no admite mensajes, simplemente concatena el valor.
            const linkSinMensaje = `${baseUrl}${red.valor || ''}`;
            return linkSinMensaje;
        },
        isWeekday() {
            const dayOfWeek = new Date().getDay();
            return dayOfWeek >= 1 && dayOfWeek <= 5; // Lunes a Viernes
        },
        isSaturday() {
            const dayOfWeek = new Date().getDay();
            return dayOfWeek === 6; // Sábado
        },
        onContactCaptchaVerified(response) {
            //console.log('reCAPTCHA verificado', response);
            this.contactCaptchaVerified = true;
        },
        onContactCaptchaExpired() {
            //console.log('reCAPTCHA expirado');
            this.contactCaptchaVerified = false;
        },

        // Callback de reCAPTCHA para el formulario de unirse
        onJoinFormCaptchaVerified(token) {
            this.joinCaptchaVerified = true;
        },

        // Callback de reCAPTCHA cuando el captcha del formulario de unirse expira
        onJoinFormCaptchaExpired() {
            this.joinCaptchaVerified = false;
        },
    },
    watch: {
        // watching nested property
        "email.value": function (value) {
            this.validate("email", value);
        }
    }
}


</script>